import { render, staticRenderFns } from "./instagram-viewer.vue?vue&type=template&id=507e83e5"
import script from "./instagram-viewer.vue?vue&type=script&lang=js"
export * from "./instagram-viewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports